const siteMetadata = {
    title: `I’LL.CO.,LTD`,
    siteUrl: `http://localhost`,
    capitalizeTitleOnHome: true,
    logo: `/images/ill-logo.png`,
    icon: `/images/ill-logo.png`,
    titleImage: `/images/ill-background.png`,
    ogImage: `/images/ill-logo.png`,
    twoColumnWall: false,
    cookiePolicy: false,
    introTag: ``,
    description: ``,
    about: "",
    author: ``,
    blogItemsPerPage: 10,
    portfolioItemsPerPage: 10,
    darkmode: false,
    switchTheme: false,
    navLinks: [
        {
            name: "HOME",
            url: "/",
        },
        {
            name: "会社概要",
            url: "/about",
        },
        {
            name: "事業概要",
            url: "/portfolio/concerts/",
        },
        {
            name: "お問い合わせ",
            url: "/contact",
        },
    ],
    footerLinks: [
        {
            name: "情報セキュリティ基本方針",
            url: "/privacy-policy",
        },
    ],
    social: [
        {
            name: "Facebook",
            icon: "/images/Facebook.svg",
            url: "#",
        },
        {
            name: "Twitter",
            icon: "/images/Twitter.svg",
            url: "#",
        },
        {
            name: "Instagram",
            icon: "/images/Instagram.svg",
            url: "#",
        },
        // {
        //     name: "Youtube",
        //     icon: "/images/Youtube.svg",
        //     url: "#",
        // },
    ],
    contact: {
        // leave empty ('') or false to hide form
        api_url: "https://getform.io/f/11babf0e-8ea6-4834-96a4-24563d9c9564",
        description: `左記のフォームへ必要事項を入力の上お問い合わせください。`,
        mail: "kanrieigyo@ill-g.jp",
        phone: "03-6418-9882",
        address: "〒150-0002 \n東京都渋谷区渋谷3-13-5 \nBPRレジデンス渋谷 1208",
    },
    disqus: "elemental-netlify-com",
}

const beforeContactFormSubmit = data => {
    // Code 0 - success
    // Code 1 - Name
    // Code 2 - Email
    // Code 3 - Message
    // Code 4 - Other
    const errors = []

    if (data.name.trim().length < 2) {
        errors.push({
            code: 1,
            message: "Enter a name",
        })
    }

    if (!data.email.match(/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/)) {
        errors.push({
            code: 2,
            message: "Enter a valid email address",
        })
    }

    if (data.message.trim().length < 15) {
        errors.push({
            code: 3,
            message: "Enter a message with atleast 15 characters",
        })
    }

    if (errors.length > 0)
        return {
            result: false,
            errors: errors,
        }

    return {
        data: {
            name: data.name,
            email: data.email,
            message: data.message,
        },
        result: true,
    }
}

const contactFormSubmit = async (api, data) => {
    let res: any = await fetch(api, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })

    res = await res.json()

    if (res.success) {
        return {
            result: true,
        }
    }
    return {
        result: false,
        ...res,
    }
}

const defaults = {
    disqus: null,
    twoColumnWall: true,
    darkmode: false,
    switchTheme: true,
    capitalizeTitleOnHome: true,
    cookiePolicy: false
}

Object.keys(defaults).forEach(item => {
    if (siteMetadata[item] === undefined) {
        siteMetadata[item] = defaults[item]
    }
})

export { siteMetadata, beforeContactFormSubmit, contactFormSubmit }
